import AppConstants from '../constants/AppConstants';
import { getTotalPages } from './helper';

export const initialState = {
    list: [],
    item: {},
    page: 1,
    total: null,
    loading: false
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {

        case AppConstants.PAYOUTS_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };

        case AppConstants.PAYOUTS_SEARCH_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.items.items,
                page: action.items.page,
                total: getTotalPages(action.items.total, action.items.count)
            };

        case AppConstants.PAYOUTS_SEARCH_ITEM_SUCCESS:
            return {
                ...state,
                loading: false,
                item: action.items.items[0] || {}
            };

        default:
            return state;
    }
};
